import type { Map, Set } from '@gonfalon/immutable-shim/immutableShim';
import type { Color } from '@gonfalon/legacy-color/colorUtils';
import type { ImmutableMap } from '@gonfalon/legacy-immutable/immutableUtils';

import type { AccessChecks } from '#utils/access/types';
import type { ApprovalSettings } from '#utils/environments/records/ApprovalSettings';
import type { PubNub } from '#utils/environments/records/PubNub';
import type { ResourceApprovalSettings } from '#utils/environments/records/ResourceApprovalSettings';
import type { Link } from '#utils/linkUtils';

export enum ApprovalResourceKind {
  FLAG = 'flag',
  SEGMENT = 'segment',
}

export enum ApprovalServiceKind {
  CustomApprovalServiceKind = 'custom-approvals',
  CustomApprovalV2ServiceKind = 'custom-approvals-v2',
  LaunchDarklyApprovalServiceKind = 'launchdarkly',
  ServiceNowApprovalServiceKind = 'servicenow',
}

export enum ApprovalRequirementStrategy {
  NONE = 'NONE',
  ALL = 'ALL',
  BY_TAG = 'BY_TAG',
}

export type PubNubProps = {
  channel: string;
  cipherKey: string;
  pubnubUuid: string;
};

export type ApprovalSettingsProps = {
  serviceKind: string;
  serviceKindConfigurationId?: string;
  serviceConfig?: Map<$TSFixMe, $TSFixMe>;
  required: boolean;
  canReviewOwnRequest: boolean;
  bypassApprovalsForPendingChanges: boolean;
  minNumApprovals: number;
  canApplyDeclinedChanges: boolean;
  requiredApprovalTags: Set<string>;
  approvalRequirementStrategy: ApprovalRequirementStrategy;
  autoApplyApprovedChanges?: boolean;
};

export type ResourceApprovalSettingsProps = ApprovalSettingsProps & {
  resourceKind: ApprovalResourceKind;
};

export type EnvironmentProps = {
  _access?: AccessChecks;
  _links: ImmutableMap<{
    analytics: Link;
    apiKey: Link;
    mobileKey: Link;
    self: Link;
    snippet: Link;
  }>;
  _id: string;
  _pubnub?: PubNub;
  _followed: boolean;
  key: string;
  apiKey: string;
  mobileKey: string;
  name: string;
  color: Color;
  defaultTtl: number;
  secureMode: boolean;
  defaultTrackEvents: boolean;
  tags: Set<string>;
  critical: boolean;
  requireComments: boolean;
  confirmChanges: boolean;
  approvalSettings?: ApprovalSettings;
  resourceApprovalSettings?: Map<ApprovalResourceKind, ResourceApprovalSettings>;
};
